import Vue from 'vue'

import VueUploadComponent from 'vue-upload-component'

Vue.component('file-upload', VueUploadComponent)
